import React, { useState } from 'react'

import { Button } from '@mui/material'
import CustomerMasterForm from 'features/agencies/components/AgencyForm'
import { useAgencyCreate } from 'features/agencies/hooks/useAgencyCreate'

import { EPlanName } from '@albacross/types'

type CustomerAgencyEnableProps = {
  isAgency: boolean
}

const CustomerAgencyEnable = ({ isAgency }: CustomerAgencyEnableProps) => {
  const [modal, setModal] = useState(false)

  const { mutateAsync: createAgency } = useAgencyCreate()

  const handleSubmit = async (values: any) => {
    await createAgency(values)
    setModal(false)
  }

  return (
    !isAgency && (
      <>
        <Button onClick={() => setModal(true)}>Create Agency Plan</Button>

        <CustomerMasterForm
          initialValues={{
            price: 0,
            currency: 'EUR',
            [EPlanName.Starter]: 0,
            [EPlanName.Pro]: 0,
            [EPlanName.Premium]: 0,
            [EPlanName.Business]: 0,
            [EPlanName.Free]: 0,
            [EPlanName.FreeUS]: 0,
            [EPlanName.Appsumo]: 0,
            [EPlanName.Enterprise]: 0,
            [EPlanName.Agency]: 0,
            [EPlanName.SelfService]: 0,
            [EPlanName.TrialEnded]: 0,
          }}
          onClose={() => setModal(false)}
          onSubmit={handleSubmit}
          open={modal}
        />
      </>
    )
  )
}

export default CustomerAgencyEnable
